// extracted by mini-css-extract-plugin
export default {"page":"OW-z","cartModal":"PW-z","checkout":"QW-z","placeholder":"RW-z","account":"SW-z"};